import railCards from './railCards.js';
import hotelSuppliers from './hotelSuppliers.js';
import railStations from './railStations.js';
import airports from './airports.js';
import pointsOfInterest from './pointsOfInterest.js';
import hotels from './hotels.js';
import carSuppliersLocations from './carSuppliersLocations.js';
import carSuppliers from './carSuppliers.js';
import railSuppliers from './railSuppliers.js';
import airlineCarriers from './airlineCarriers.js';
import creditCards from './creditCards.js';
import settingsResource from './settingsResource.js';
import globalSettings from './globalSettingsResource.js';
import debtors from './debtors.js';
import ctmDebtors from './ctmDebtors.js';
import logs from './logs.js';
import enhancedLogs from './enhancedLogs.js';
import flyAmerica from './flyAmericaAct.js';
import companyReferenceList from './companyReferenceList.js';
import companyReferenceConfig from "./companyReferenceConfig.js";
import enhancedPolicyRules from "./enhancedPolicyRules.js";
import processUploadStatus from "./processUploadStatus.js";
import perDiem from './perDiem.js';
import vendorPreferenceConfigs from './vendorPreferenceConfigs.js';
import safScores from './safScores.js';

export default Object.assign({},
    railCards,
    hotelSuppliers,
    railStations,
    airports,
    pointsOfInterest,
    hotels,
    carSuppliersLocations,
    carSuppliers,
    railSuppliers,
    airlineCarriers,
    creditCards,
    settingsResource,
    globalSettings,
    debtors,
    ctmDebtors,
    logs,
    enhancedLogs,
    flyAmerica,
    companyReferenceList,
    companyReferenceConfig,
    enhancedPolicyRules,
    processUploadStatus,
    perDiem,
    vendorPreferenceConfigs,
    safScores);



// WEBPACK FOOTER //
// ./src/config/fields/index.js